function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9422 0H2.96328C1.86521 0 0.966797 0.9 0.966797 2V18C0.966797 19.1 1.86521 20 2.96328 20H14.9422C16.0402 20 16.9386 19.1 16.9386 18V2C16.9386 0.9 16.0402 0 14.9422 0ZM5.95799 2H7.95447V7L6.95623 6.25L5.95799 7V2ZM2.96328 18H14.9422V2H9.95095V11L6.95623 8.75L3.96152 11V2H2.96328V18Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/search_manufacturer.7f2bafd1.svg";
export { SvgComponent as ReactComponent };